import { gql } from '@apollo/client';

export const RESOURCE_ROW_FRAGMENT = gql`
  fragment ResourceRowFragment on Resource {
    id
    index
    rank
    publicId
    parentId
    workspaceId
    name
    type
    canDownload
    mimeType
    size
    pspdfKitId
    isFavorite
    createdBy {
      id
      firstName
      lastName
      email
      pictureURL
    }
    createdAt
    updatedAt
    archivedAt
  }
`;
